import { QUERY_KEY } from 'constants/globalConstants'
import DashboardService from 'apiService/dashboardService'
import { useQuery } from 'react-query'

const useGetMtbf = (order) => {
    return useQuery(QUERY_KEY.GET_MTBF, ()=>DashboardService.getMtbf(order), {retry: false})
}

export default useGetMtbf